import * as zod from 'zod';

// Permissive shape: a `type` discriminator plus any extra fields. Each
// block kind's strict schema lives with the orchestrator that produces it.
export const ContentBlock = zod
  .object({
    type: zod.string(),
  })
  .passthrough();

export type ContentBlock = zod.infer<typeof ContentBlock>;
